var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audit-event-viewer',{attrs:{"fetch-method":_vm.retrievalFunc,"page-size":10}})}
var staticRenderFns = []

export { render, staticRenderFns }